module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings/settings.component.scss
// module id = ./src/app/settings/settings/settings.component.scss
// module chunks = main